import { graphql } from "react-relay";

export const eventPersonalCalendarInfoFragments = {
  eventParent: graphql`
    fragment EventPersonalCalendarInfo_eventParent on EventParent {
      id
      externalEventId
      syncedOriginEventErrorable {
        ... on Event {
          __typename
          title
        }
        ... on GraphEntityError {
          __typename
          statusCode
          message
        }
      }
    }
  `,
};
